import React, { Component } from 'react'

import fctped from '../../assets/4ctpedfull512.png';
import sss from '../../assets/sss.png';
import silc from '../../assets/silc.png';
export default class index extends Component {
    render() {
        return (
            <div style={{ padding: 20, }}>
                <center>
                    <h1 style={{ fontSize: 100 }}>PEDUbon</h1>
                    <h1>โครงการสร้างเสริมสุขภาวะเด็กและเยาวชนจังหวัดอุบลราชธานี</h1>
                    <hr style={{ width: '80%' }}></hr>
                </center>
                <div style={{ marginLeft: '15%' }}>
                    <h1>นโยบายข้อมูล</h1>
                    <p>นโยบายนี้จะอธิบายถึงข้อมูลที่เราประมวลผลเพื่อสนับสนุน PEDUbon ในการเก็บข้อมูลเกี่ยวกับชุมชน จังหวัดอุบลราชธานี</p>
                    <li>การเก็บข้อมูล</li>
                    <p style={{ marginLeft: 50 }}>จัดเก็บข้อมูลส่วนตัวและรูปถ่ายเพื่อยืนยันตัวตนในการเข้าใช้งาน</p>
                    <p style={{ marginLeft: 50 }}>จัดเก็บข้อมูลตำแหน่งเพื่อบันทึกข้อมูลของชุมชน</p>
                    <p style={{ marginLeft: 50 }}>จัดเก็บข้อมูลเกี่ยวกับชุมชน</p>
                    <p style={{ marginLeft: 50 }}>จัดเก็บข้อมูลบุคคลที่ทำงานด้านเด็กและเยาวชน จังหวัดอุบลราชธานี</p>
                    <li>การใช้ข้อมูล</li>
                    <p style={{ marginLeft: 50 }}>การนำข้อมูลมาเป็นส่วนประกอบในการพัฒนาชุมชน</p>
                    <p style={{ marginLeft: 50 }}>การนำข้อมูลมาวิเคราะห์ เพื่อสร้างกระบวนการ หรือหาแนวางในการ พัฒนาเด็๋กและเยาวชน</p>


                </div>

                <center>
                    <hr style={{ width: '80%' }}></hr>
                    <div style={{ padding: 20, }}>
                        <img src={fctped} style={{ width: 200, height: 200 }}></img>
                        <img src={sss} style={{ width: 200, height: 200 }}></img>
                        <img src={silc} style={{ width: 200, height: 200 }}></img>
                    </div>
                    <div id="foot">
                        <h3>โครงการสร้างเสริมสุขภาวะเด็กและเยาวชนจังหวัดอุบลราชธานี พื้นที่ อุบลราชธานี</h3>
                        <h4>พัฒนาโดย นายอดิศร ราชชิต email: adion.ra.56@ubu.ac.th</h4>
                    </div>

                </center>


            </div>
        )
    }
}
